module.exports = __webpack_public_path__ + "media/images/create-encounter-6991daf727dd9e73c7430ed5ae86aa65752a01a2b5032aa6f357eff88b811c40.svg";